import {
  searchUsers as searchUsersRepository,
  getAnotherUserInfo as getAnotherUserInfoRepository,
  unFollow as unFollowRepository,
  getBlockedList as getBlockedListRepository
} from "../repositories/UsersRepository";

const getUserSearchKey = (user = {}) =>
  user.idUsuario ??
  user.IdUsuario ??
  user.idAmigo ??
  user.IdAmigo ??
  user.userId ??
  user.nickName ??
  user.email ??
  `${user.nombres ?? ""}-${user.apellidos ?? ""}`;

const getUniqueUsers = (users = []) => {
  const seen = new Set();

  return users.filter((user) => {
    const key = getUserSearchKey(user);

    if (!key || seen.has(key)) {
      return false;
    }

    seen.add(key);
    return true;
  });
};

export const searchUserService = async (search) => {
  try {
    const users = await searchUsersRepository(search)
    return getUniqueUsers(users)
  } catch (error) {
    throw error
  }
}

export const findUserByNicknameService = async ({ nickname, idUsuario }) => {
  const normalizedNickname = nickname?.startsWith("@")
    ? nickname.toLowerCase()
    : `@${nickname || ""}`.toLowerCase();
  const criteriaOptions = Array.from(
    new Set([nickname, nickname?.replace(/^@/, "")].filter(Boolean)),
  );

  for (const criteria of criteriaOptions) {
    const users = await searchUserService({ Criteria: criteria, IdUsuario: idUsuario });
    const exactUser = users.find((user) => {
      const userNickname = user?.nickName || user?.nickname || "";
      const normalizedUserNickname = userNickname.startsWith("@")
        ? userNickname.toLowerCase()
        : `@${userNickname}`.toLowerCase();
      return normalizedUserNickname === normalizedNickname;
    });

    if (exactUser?.idUsuario) return exactUser;
  }

  return null;
}

export const getAnotherUserInfoService = async (userId, otherId) => {
  try {
    return await getAnotherUserInfoRepository(userId, otherId)
  } catch (error) {
    throw error
  }
}

export const unFollowService = async (relation) => {
  try {
    return await unFollowRepository(relation)
  } catch (error) {
    throw error
  }
}

export const getBlockListService = async (userId) => {
  try {
    return await getBlockedListRepository(userId)
  } catch (error) {
    throw error
  }
}
